// extracted by mini-css-extract-plugin
module.exports = {"tk-shell":"Shell_tk-shell__LeORD"};